import { ReactNode } from "react";

import { css } from "@compiled/react";

import Form from "@atlaskit/form";
import { N700 } from "@atlaskit/theme/colors";

import { useSiteActivationContext } from "../../hooks/site-activation-context";
import { SiteNameInput as DefaultSiteNameInput } from "../common/site-name-input";

import { HelperText as DefaultHelperText } from "./helper-text";
import { NewUserSubmitButton as DefaultSubmitButton } from "./submit-button";

export const Content = ({
    SiteNameInput = <DefaultSiteNameInput />,
    HelperText = <DefaultHelperText />,
    SubmitButton = <DefaultSubmitButton />
}: {
    SiteNameInput?: ReactNode;
    HelperText?: ReactNode;
    SubmitButton?: ReactNode;
}) => {
    const { activateSite } = useSiteActivationContext();

    return (
        <Form onSubmit={activateSite} isDisabled={false}>
            {({ formProps }) => (
                <form
                    {...formProps}
                    autoComplete="off"
                    css={containerCss}
                    data-testid="new-user-site-activation"
                >
                    {SiteNameInput}
                    {HelperText}
                    {SubmitButton}
                </form>
            )}
        </Form>
    );
};

const containerCss = css({
    color: N700
});
